import { Component } from '@angular/core';

interface InvoiceItem {
  description: string;
  quantity: number;
  unit_price: number;
  total_price: number;
  currency?: string;
}

@Component({
  selector: 'app-items-table',
  templateUrl: './items-table.component.html',
  styleUrls: ['./items-table.component.css'],
})
export class ItemsTableComponent {
  tableData: InvoiceItem[] = [];

  displayTable(body: any) {
    if (body?.ocr_plus_data?.items) {
      this.tableData = body.ocr_plus_data.items;
    }
  }
}
